/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportUserBodyItem } from './ImportUserBodyItem';
import {
    ImportUserBodyItemFromJSON,
    ImportUserBodyItemFromJSONTyped,
    ImportUserBodyItemToJSON,
    ImportUserBodyItemToJSONTyped,
} from './ImportUserBodyItem';

/**
 * 
 * @export
 * @interface ImportUserBody
 */
export interface ImportUserBody {
    /**
     * 
     * @type {Array<ImportUserBodyItem>}
     * @memberof ImportUserBody
     */
    data?: Array<ImportUserBodyItem>;
}

/**
 * Check if a given object implements the ImportUserBody interface.
 */
export function instanceOfImportUserBody(value: object): value is ImportUserBody {
    return true;
}

export function ImportUserBodyFromJSON(json: any): ImportUserBody {
    return ImportUserBodyFromJSONTyped(json, false);
}

export function ImportUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ImportUserBodyItemFromJSON)),
    };
}

export function ImportUserBodyToJSON(json: any): ImportUserBody {
    return ImportUserBodyToJSONTyped(json, false);
}

export function ImportUserBodyToJSONTyped(value?: ImportUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ImportUserBodyItemToJSON)),
    };
}

